import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-3, trends, upward"} maskId="square-filled-radius-0-stroke-1-IconTrending3"><path fillRule="evenodd" clipRule="evenodd" d="M16.0001 6H22.0001V12H21.0001V7.72842L12.9996 15.7066L9.00008 11.7071L2.50008 18.2071L1.79297 17.5L9.00008 10.2929L13.0006 14.2934L20.3143 7H16.0001V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrending3;
